import * as React from 'react';
import happyFlatfy from '../../../images/happy-flatfy.svg';
import * as styles from './SucessForm.module.scss';

const SuccessForm = () => (
  <div className={styles.root}>
    <div>
      <div className={styles.container}>
        <p>Thank you!</p>
        <p>Your message has been</p>
        <p>sent successfully</p>
      </div>
      <img src={happyFlatfy} alt='Flatfy success form'/>
    </div>
  </div>
);

export default SuccessForm;